export const getFieldsFromExpression = (expression: string) => {
  const expressionFields = expression.split(';')
  return expressionFields
    .map((item) => item.substring(1, 4))
    .filter((item) => item)
}
